import actions from './actions';

const initState = {
	dataSummarizeWrittenText: [],
	summarizeWrittenTextDetail: {},
	totalItems: 0,
	loading: false,
};

export default function readAloudReducer(state = initState, action) {
	switch (action.type) {
		case actions.GET_SUMMARIZE_WRITTEN_TEXT:
			return { ...state, totalItems: 0, loading: true };
		case actions.GET_SUMMARIZE_WRITTEN_TEXT_SUCCESS:
			let { data, totalItems } = action.payload;
			let res = data ? data : [];
			return { ...state, dataSummarizeWrittenText: res, totalItems, loading: false };

		case actions.GET_SUMMARIZE_WRITTEN_TEXT_DETAIL:
			return { ...state, loading: true, totalItems: 0 };
		case actions.GET_SUMMARIZE_WRITTEN_TEXT_DETAIL_SUCCESS: {
			let { data } = action.payload;
			let res = data ? data : {};
			return { ...state, summarizeWrittenTextDetail: res, loading: false };
		}

		case actions.WRITING_LOADING_FALSE: {
			return { ...state, loading: false };
		}

		default:
			return state;
	}
}
